import React from "react"
import { Redirect } from "react-router-dom"



import Pages404 from "../pages/error/page-404";
import ProjectWorksheet from "../pages/Worksheets/index";
import WorksheetPreview from "../pages/Worksheets/preview"
import ProjectWorksheetThank from "../pages/Worksheets/thank";
import ProjectOpenHouseForm from "../pages/OpenHouse/index"
import SellerPage from "../pages/OpenHouse/seller"
import ProjectInviteUser from "../pages/event/index"
import landingPage from "../pages/landing-page/index";
import PreviewPage from "../pages/landing-page/preview"
import PreviewOtherPage from "../pages/landing-page/preview-other"
import UnsubscribePage from '../pages/landing-page/unsubscribe'
import ProjectDownload from "../pages/download/index"
import WorksheetSent from "../pages/worksheet-landing/index"
import RefferForm from "../pages/landing-page/referral"
import SurveyForm from "../pages/landing-page/survey"
import OpenHouseFrm from "../pages/landing-page/openhouse";
import openhouselead from "pages/OpenHouse/openhouselead";
import {
  AssignmentPage,
  EventPage,
  PublicPage,
  ReferralsPage,
  ValuationPage,
} from "../pages/lead-generation";

const authProtectedRoutes = [
  
]

const publicRoutes = [
//{ path: "/thank-you/:worksheetId", component: ProjectWorksheetThank },
//{ path: "/preview/:worksheetId", component: WorksheetPreview },
//{ path: "/:worksheetId", component: ProjectWorksheet },

//{ path: "/preview/:projectId/:templateId/:agentId", component: PreviewPage },
//{ path: "/seller/:openhouseid", component: SellerPage },
//{ path: "/preview/:projectId", component: PreviewOtherPage },
//{ path: "/referral/:contactId", component: RefferForm },
//{ path: "/survey/:contactId", component: SurveyForm },
//{ path: "/openhouse/:contactId", component: OpenHouseFrm },
//{ path: "/openhouselead/:contactId", component: openhouselead },

  // Lead generation (copied from rs-pages) — must be before /:projectId
  { path: "/lg/assignment/:slug", component: AssignmentPage },
  { path: "/lg/events/:slug", component: EventPage },
  { path: "/lg/download/:slug", component: EventPage },
  { path: "/lg/open-house/:slug", component: EventPage },
  { path: "/lg/openhouse/:slug", component: EventPage },
  { path: "/lg/valuation/:slug", component: ValuationPage },
  { path: "/lg/referrals/:slug", component: ReferralsPage },
  { path: "/lg/:slug", component: PublicPage },
  { path: "/lg", component: PublicPage, exact: true },

{ path: "/unsubscribe", component: UnsubscribePage, exact: true },
// exact: true so /lg/... is NOT treated as projectId
{ path: "/:projectId", component: landingPage, exact: true },

//{ path: "/:openhouseid", component: ProjectOpenHouseForm },

//{ path: "/:openhouseid", component: WorksheetSent },
//{ path: "/:openhouseid", component: ProjectDownload },
//{ path: "/:projectEventInviteId", component: ProjectInviteUser },
  { path: "/", component: Pages404, exact: true }
]

export { authProtectedRoutes, publicRoutes }
